// Generated by CoffeeScript 1.11.1
(function() {
  var Mask;

  Mask = require('../mask');

  module.exports = {
    parseMaskData: function() {
      return this.mask = new Mask(this.file).parse();
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer/mask.js
// module id = 55
// module chunks = 0